export default function TrustBar() {
  return (
    <section className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex items-center justify-center space-x-4">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full">
              <i className="ri-award-line text-3xl text-teal-600"></i>
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">20+ Years</div>
              <div className="text-sm text-gray-600">Experience</div>
            </div>
          </div>
          <div className="flex items-center justify-center space-x-4">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full">
              <i className="ri-chat-smile-3-line text-3xl text-teal-600"></i>
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">Free</div>
              <div className="text-sm text-gray-600">Consultation</div>
            </div>
          </div>
          <div className="flex items-center justify-center space-x-4">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full">
              <i className="ri-hand-coin-line text-3xl text-teal-600"></i>
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">No Fee</div>
              <div className="text-sm text-gray-600">Unless We Win</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}